import type { Profile } from './types';

/**
 * Content transcribed from Ravi_Resume_v6.1.pdf (PLAN.md §3.1).
 *
 * Note on `phone`: this is deliberately NOT rendered anywhere in the site's
 * markup. It is consumed only by scripts/build-resumes.ts so recruiters get it
 * in the downloaded file while HTML scrapers do not — §11.5.
 */
export const profile: Profile = {
  name: 'Venkata Ravi Teja Sandram',
  shortName: 'Ravi Teja Sandram',
  title: 'Java & Spring Backend Engineer',
  tagline:
    'I build reliable backend systems — and treat reliability as a build-time requirement, not a runtime hope.',

  summary: [
    'Java and Spring backend engineer with 5+ years in enterprise systems, who independently designed and built a distributed LLM inference platform with worker scheduling, health monitoring, and automatic failure recovery.',
    'Treat reliability and code quality as build-time requirements: 100% coverage enforced as build-failing gates, heartbeat-based worker monitoring, and automatic requeue of in-flight tasks on worker failure.',
    'Deliver production Spring Boot REST microservices across banking and automotive manufacturing, promoted from Assistant System Engineer Trainee to System Engineer over 4+ years at Tata Consultancy Services.',
  ],

  location: 'Houston, TX',
  email: 'raviteja1054@gmail.com',
  phone: '+1 682-416-8462',

  links: {
    github: 'https://github.com/RSRev27',
    linkedin: 'https://www.linkedin.com/in/venkataravitejas',
  },

  // Drop a real portrait at public/headshot.jpg and set this to
  // 'headshot.jpg' with photoIsPlaceholder: false. The placeholder badge in
  // the About section disappears on its own.
  photo: 'headshot-placeholder.svg',
  photoIsPlaceholder: true,

  // Every figure here is attributable and defensible under questioning.
  // "100% coverage" was deliberately dropped: it belongs to the personal
  // project, and stated bare it reads as metric-gaming rather than rigour.
  stats: [
    { label: 'Years in enterprise systems', value: '5+' },
    { label: 'Services owned at TCS', value: '10–12' },
    { label: 'Records per batch run', value: '200K–500K' },
    { label: 'Test coverage driven', value: '0 → 80%' },
  ],
};
